import React, {useEffect, useRef, useState} from 'react';
import styled, { ThemeProvider } from 'styled-components/macro';
import {theme} from "./theme";
import GlobalStyles from "./components/ui/global";
import EmployeeHome from './components/EmployeeHome';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Home from "./components/Home";
import {Drawer} from "./components/ui/Drawer";
import ClientList from './components/ClientList';

const NavBar = styled.nav`
  display: flex;
  background-color: #C3C8CC;
  position: fixed;
  top: 0;
  width: 100%;
  transition: top 0.3s;
  height: 60px;
  z-index: 1;
  -webkit-box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
  align-items: stretch;
  
  
  span {
    position: relative;
    text-decoration: none;
    font-size: 1rem;
    color: black;
    padding: 4px 0;
    transition: 0.5s;
    margin: 16px;
    display: none;
  }

  @media screen and (max-width: 600px) {
    a:not(:first-child), a:not(:nth-child(2)) {
      display: none;
    }
    span {
      float: left;
      display: block;
    }
    #Logo {
      display: block;
      float: right;
    }
`;

const NavBarLink = styled(Link)`
  position: relative;
  display: block;
  text-decoration: none;
  font-size: 1rem;;
  color: black;
  padding: 4px 0;
  transition: 0.5s;
  margin: 16px;
  
  &::after { 
    position: absolute;
    content: "";
    width: 100%;
    height: 3px;
    top: 100%;
    left: 0;
    background: #ff7000;
    // background: #ffc106;
    transition: transform 0.5s;
    transform: scaleX(0);
    transform-origin: right;
  }
  &:hover {
    background-color: #C3C8CC99;
  }
  &:hover::after {
    transform: scaleX(1);
    transform-origin: left;
  }
`;

const Logo = styled(Link)`
  font-family: ${props => props.theme.fontLogo};
  
  position: relative;
  display: block;
  text-decoration: none;
  font-size: 1rem;;
  color: black;
  padding: 4px 0;
  transition: 0.5s;
  margin: 16px;
  
  &::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 3px;
    top: 100%;
    left: 0;
    background: #ff7000;
  }
`;

const MenuIcon = ({clickAction}) => <span onClick={()=> clickAction()} className="material-icons">
menu
</span>

function App() {
  const [drawerClosing, setDrawerClosing] = useState(false);
  const [drawerOpen, setDrawer] = useState(false);
  const toggleDrawer = () => { setDrawer(!drawerOpen) };
  const prevScrollY = useRef(0);
  const [goingUp, setGoingUp] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (prevScrollY.current < currentScrollY && goingUp && currentScrollY > 60) {
        setGoingUp(false);
      }
      if (prevScrollY.current > currentScrollY && !goingUp) {
        setGoingUp(true);
      }

      prevScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [goingUp]);

  const callback = () => e => {
    if(e.animationName === 'SlideOut') {
      setDrawer(false);
      setDrawerClosing(false);
    }
  }

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <GlobalStyles/>
        <NavBar style={ goingUp ? {top: '0px'} : {top: '-60px'}}>
          <MenuIcon clickAction={toggleDrawer}/>
          <Logo id="Logo" to='/'>Marshall Carter & Dark</Logo>
          <NavBarLink style={{marginLeft: '50px'}} to='/'>Home</NavBarLink>
          {/*
          <NavBarLink to='/services'>Services</NavBarLink>
          <NavBarLink to='/contact'>Contact</NavBarLink>
          <NavBarLink to='/about'>About</NavBarLink>
          <NavBarLink to='/login'>Login</NavBarLink>
          */}
        </NavBar>
        <Drawer onClick={() => setDrawerClosing(true)} style={drawerOpen ? {display: 'block'} : {display: 'none'}}
                className = {`SideNav-content ${drawerClosing ? 'ClosedDrawer' : 'OpenDrawer'}`}
                onAnimationEnd={callback()}>
          <div className='SideNav-header'>
            <div className='SideNav-Header-item'><Logo id="Logo" to='/'>Marshall Carter & Dark</Logo></div>
          </div>
          <Link className="SideNav-item" to='/'>Home</Link>
          {/*
          <Link className="SideNav-item" to='/services'>Services</Link>
          <Link className="SideNav-item" to='/contact'>Contact</Link>
          <Link className="SideNav-item" to='/about'>About</Link>
          <Link className="SideNav-item" to='/login'>Login</Link>
          */}
        </Drawer>

        <Switch>
          <Route exact path='/'>
            <Home/>
          </Route>
          <Route path='/login'>
            <EmployeeHome/>
          </Route>
          <Route path='/clients'>
            <ClientList/>
          </Route>
        </Switch>

      </ThemeProvider>
    </Router>
  );
}

export default App;
